/* empty css           */
import { registerCustomElement as r } from "./api/custom-element-register.js";
import { getCustomElementSuffix as ms, setCustomElementSuffix as is } from "./api/custom-element-scope.js";
import { Icon as o } from "./foundations/icon/icon.js";
import { Typography as t } from "./foundations/typography/typography.js";
import { Accordion as s } from "./components/accordion/accordion.js";
import { ActionMenuItem as m } from "./components/action-menu-item/action-menu-item.js";
import { ActionMenu as i } from "./components/action-menu/action-menu.js";
import { Alert as e } from "./components/alert/alert.js";
import { Avatar as d } from "./components/avatar/avatar.js";
import { BadgeButton as p } from "./components/badge-button/badge-button.js";
import { Badge as a } from "./components/badge/badge.js";
import { BreadcrumbBar as f } from "./components/breadcrumb-bar/breadcrumb-bar.js";
import { Button as n } from "./components/button/button.js";
import { Calendar as c } from "./components/calendar/calendar.js";
import { ChatMessage as u } from "./components/chat-message/chat-message.js";
import { Checkbox as l } from "./components/checkbox/checkbox.js";
import { Chip as b } from "./components/chip/chip.js";
import { ContentSwitcher as g } from "./components/content-switcher/content-switcher.js";
import { CustomTableHeader as h } from "./components/custom-table-header/custom-table-header.js";
import { CustomTable as k } from "./components/custom-table/custom-table.js";
import { DatepickerRange as C } from "./components/datepicker-range/datepicker-range.js";
import { Datepicker_ as B } from "./components/datepicker/datepicker.js";
import { DecorativeIcon as S } from "./components/decorative-icon/decorative-icon.js";
import { Divider as I } from "./components/divider/divider.js";
import { Drawer as F } from "./components/drawer/drawer.js";
import { Footer as T } from "./components/footer/footer.js";
import { HeaderLinks as x } from "./components/header-links/header-links.js";
import { HeaderMenuPatient as w } from "./components/header-menu-patient/header-menu-patient.js";
import { HeaderMenuProfessional as v } from "./components/header-menu-professional/header-menu-professional.js";
import { IconBadge as D } from "./components/icon-badge/icon-badge.js";
import { IconButton as L } from "./components/icon-button/icon-button.js";
import { InputAction as P } from "./components/input-action/input-action.js";
import { InputDropdown as H } from "./components/input-dropdown/input-dropdown.js";
import { InputSwitch as M } from "./components/input-switch/input-switch.js";
import { Input as y } from "./components/input/input.js";
import { ItemListBase as A } from "./components/item-list-base/item-list-base.js";
import { ItemList as R } from "./components/item-list/item-list.js";
import { Legend as E } from "./components/legend/legend.js";
import { Link as _ } from "./components/link/link.js";
import { ListMenu as G } from "./components/list-menu/list-menu.js";
import { Modal as U } from "./components/modal/modal.js";
import { ModuleHeader as N } from "./components/module-header/module-header.js";
import { NotificationBadge as O } from "./components/notification-badge/notification-badge.js";
import { Pagination as W } from "./components/pagination/pagination.js";
import { Popover as j } from "./components/popover/popover.js";
import { PopoverBody as q } from "./components/popover/popover-body.js";
import { PopoverFooter as z } from "./components/popover/popover-footer.js";
import { ProgressIndicator as J } from "./components/progress-indicator/progress-indicator.js";
import { RadioButton as K } from "./components/radio-button/radio-button.js";
import { Selector as Q } from "./components/selector/selector.js";
import { SidemenuListItem as V } from "./components/sidemenu-list-item/sidemenu-list-item.js";
import { SidemenuList as X } from "./components/sidemenu-list/sidemenu-list.js";
import { Skeleton as Y } from "./components/skeleton/skeleton.js";
import { Slider as Z } from "./components/slider/slider.js";
import { Spinner as $ } from "./components/spinner/spinner.js";
import { SplitButton as rr } from "./components/split-button/split-button.js";
import { Stepper as or } from "./components/stepper/stepper.js";
import { TablePagination as tr } from "./components/table-pagination/table-pagination.js";
import { TabsList as sr } from "./components/tabs-list/tabs-list.js";
import { TabsPanel as mr } from "./components/tabs-panel/tabs-panel.js";
import { Textarea as ir } from "./components/textarea/textarea.js";
import { Tile as er } from "./components/tile/tile.js";
import { Timepicker as dr } from "./components/timepicker/timepicker.js";
import { Toast as pr } from "./components/toast/toast.js";
import { Tooltip as ar } from "./components/tooltip/tooltip.js";
import { UploadBox as fr } from "./components/upload-box/upload-box.js";
import { UserFeedback as nr } from "./components/user-feedback/user-feedback.js";
import { SearchBar as cr } from "./deprecated/search-bar/search-bar.js";
import { Card as ur } from "./collections/card/card.js";
import { CardBody as lr } from "./collections/card/partials/card-body.js";
import { CardDescription as br } from "./collections/card/partials/card-description.js";
import { CardFooter as gr } from "./collections/card/partials/card-footer.js";
import { CardForm as hr } from "./collections/card/partials/card-form.js";
import { CardHeader as kr } from "./collections/card/partials/card-header.js";
import { CardHighlights as Cr } from "./collections/card/partials/card-highlights.js";
import { CardHighlightsItem as Br } from "./collections/card/partials/card-highlights-item.js";
import { CardImage as Sr } from "./collections/card/partials/card-image.js";
import { CardInfo as Ir } from "./collections/card/partials/card-info.js";
import { CardInfoItem as Fr } from "./collections/card/partials/card-info-item.js";
import { CardMenu as Tr } from "./collections/card/partials/card-menu.js";
import { CardSubitle as xr } from "./collections/card/partials/card-subtitle.js";
import { CardTags as wr } from "./collections/card/partials/card-tags.js";
import { CardTitle as vr } from "./collections/card/partials/card-title.js";
import { Header as Dr } from "./collections/header/header.js";
import { PresetTexts as Lr } from "./collections/preset-texts/preset-texts.js";
import { Sidemenu_ as Pr } from "./collections/side-menu/side-menu.js";
import { Sidebar as Hr } from "./collections/sidebar/sidebar.js";
import { Widget as Mr } from "./collections/widget/widget.js";
import { Breadcrumb as yr } from "./deprecated/breadcrumb/breadcrumb.js";
import { ButtonLink as Ar } from "./deprecated/button-link/button-link.js";
import { DatePicker as Rr } from "./deprecated/datepicker/date-picker.js";
import { DropDownList as Er } from "./deprecated/dropdown-list/dropdown-list.js";
import { InputField as _r } from "./deprecated/input-field/input-field.js";
import { Sidemenu as Gr } from "./deprecated/sidemenu/sidemenu.js";
import { Switch as Ur } from "./deprecated/switch/switch.js";
import { Table as Nr } from "./deprecated/table/table.js";
import { FormCheckboxGroup as Or } from "./components/form-checkbox-group/form-checkbox-group.js";
import { FormCheckbox as Wr } from "./components/form-checkbox/form-checkbox.js";
import { FormDatepickerRange as jr } from "./components/form-datepicker-range/form-datepicker-range.js";
import { FormDatepicker as qr } from "./components/form-datepicker/form-datepicker.js";
import { FormInput as zr } from "./components/form-input/form-input.js";
import { FormRadioButtonGroup as Jr } from "./components/form-radio-button-group/form-radio-button-group.js";
import { FormRadioButton as Kr } from "./components/form-radio-button/form-radio-button.js";
import { FormSelectOptions as Qr } from "./components/form-select-options/form-select-options.js";
import { FormSelect as Vr } from "./components/form-select/form-select.js";
import { FormTextarea as Xr } from "./components/form-textarea/form-textarea.js";
import { FormTimepicker as Yr } from "./components/form-timepicker/form-timepicker.js";
import { FormToggle as Zr } from "./components/form-toggle/form-toggle.js";
import { SearchBar_ as $r } from "./components/searchbar/searchbar.js";
r("dss-accordion", s);
r("dss-action-menu", i);
r("dss-action-menu-item", m);
r("dss-alert", e);
r("dss-avatar", d);
r("dss-badge", a);
r("dss-badge-button", p);
r("dss-button", n);
r("dss-breadcrumb-bar", f);
r("dss-calendar", c);
r("dss-chat-message", u);
r("dss-checkbox", l);
r("dss-chip", b);
r("dss-content-switcher", g);
r("dss-custom-table", k);
r("dss-custom-table-header", h);
r("dss-datepicker", B);
r("dss-datepicker-range", C);
r("dss-decorative-icon", S);
r("dss-divider", I);
r("dss-drawer", F);
r("dss-footer", T);
r("dss-header-links", x);
r("dss-header-menu-patient", w);
r("dss-header-menu-professional", v);
r("dss-icon", o);
r("dss-icon-badge", D);
r("dss-icon-button", L);
r("dss-input", y);
r("dss-input-action", P);
r("dss-input-dropdown", H);
r("dss-input-switch", M);
r("dss-item-list", R);
r("dss-item-list-base", A);
r("dss-list-menu", G);
r("dss-link", _);
r("dss-legend", E);
r("dss-modal", U);
r("dss-module-header", N);
r("dss-notification-badge", O);
r("dss-pagination", W);
r("dss-progress-indicator", J);
r("dss-radio-button", K);
r("dss-search-bar", cr);
r("dss-selector", Q);
r("dss-slider", Z);
r("dss-spinner", $);
r("dss-stepper", or);
r("dss-skeleton", Y);
r("dss-tabs-list", sr);
r("dss-tabs-panel", mr);
r("dss-table-pagination", tr);
r("dss-textarea", ir);
r("dss-tile", er);
r("dss-timepicker", dr);
r("dss-toast", pr);
r("dss-tooltip", ar);
r("dss-typography", t);
r("dss-popover", j);
r("dss-popover-body", q);
r("dss-popover-footer", z);
r("dss-sidemenu-list", X);
r("dss-sidemenu-list-item", V);
r("dss-split-button", rr);
r("dss-user-feedback", nr);
r("dss-upload-box", fr);
r("dss-sidebar", Hr);
r("dss-card", ur);
r("dss-card-body", lr);
r("dss-card-description", br);
r("dss-card-footer", gr);
r("dss-card-form", hr);
r("dss-card-header", kr);
r("dss-card-highlights-item", Br);
r("dss-card-highlights", Cr);
r("dss-card-image", Sr);
r("dss-card-info-item", Fr);
r("dss-card-info", Ir);
r("dss-card-menu", Tr);
r("dss-card-subtitle", xr);
r("dss-card-tags", wr);
r("dss-card-title", vr);
r("dss-header", Dr);
r("dss-preset-texts", Lr);
r("dss-side-menu", Pr);
r("dss-widget", Mr);
r("dss-button-link", Ar);
r("dss-breadcrumb", yr);
r("dss-date-picker", Rr);
r("dss-dropdownlist", Er);
r("dss-input-field", _r);
r("dss-table", Nr);
r("dss-sidemenu", Gr);
r("dss-switch", Ur);
r("dss-form-input", zr);
r("dss-form-checkbox", Wr);
r("dss-form-checkbox-group", Or);
r("dss-form-radio-button", Kr);
r("dss-form-radio-button-group", Jr);
r("dss-form-select", Vr);
r("dss-form-select-options", Qr);
r("dss-form-toggle", Zr);
r("dss-form-datepicker", qr);
r("dss-form-datepicker-range", jr);
r("dss-form-timepicker", Yr);
r("dss-form-textarea", Xr);
r("dss-searchbar", $r);
export {
  ms as getCustomElementSuffix,
  is as setCustomElementSuffix
};
//# sourceMappingURL=index.js.map
